import { C } from "@/brand/tokens";
import { SiteHeader } from "@/components/layout/SiteHeader";
import { SiteFooter } from "@/components/layout/SiteFooter";
import {
  HeroSection,
  ProblemRecognitionSection,
  HowSupportWorksSection,
  TrustAnchorsSection,
  PathwaysSection,
  InquiryFlowSection,
  InquiryFormSection,
} from "@/components/sections";

/**
 * Concept 4 — Faith 1st production homepage.
 *
 * Architectural redesign (2026-02-26).
 *
 * Surface rhythm (top to bottom):
 *   1. Hero                 — Deep Mineral Blue
 *   2. Problem Recognition  — Smoked Ink
 *   3. How Support Works    — Dry Stone
 *   4. Trust Anchors        — Smoked Ink
 *   5. Engagement Pathways  — Deep Mineral Blue
 *   6. Inquiry Flow         — Dry Stone
 *   7. Inquiry Form         — Soft Parchment  (rare reveal)
 *   8. Footer               — Smoked Ink
 *
 * Each chamber owns its surface; the main wrapper carries Smoked Ink as
 * fallback so the document never flashes white.
 */
export default function ConceptD() {
  return (
    <main
      data-testid="concept-d"
      className="min-h-screen"
      style={{
        background: C.bgDark,
        color: C.textOnDark,
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* ConceptSwitcher intentionally omitted on Concept 4 — production view */}
      <SiteHeader />

      <HeroSection />
      <ProblemRecognitionSection />
      <HowSupportWorksSection />
      <TrustAnchorsSection />
      <PathwaysSection />
      <InquiryFlowSection />
      <InquiryFormSection />

      <SiteFooter />
    </main>
  );
}
